import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPortfolioColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 11,
			fill: "url(#paint0_angular_529_4480)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 20C31 18.5555 30.7155 17.1251 30.1627 15.7905C29.6099 14.4559 28.7996 13.2433 27.7782 12.2218C26.7567 11.2004 25.5441 10.3901 24.2095 9.83733C22.8749 9.28452 21.4445 9 20 9L20 20H31Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
			id: "paint0_angular_529_4480",
			cx: 0,
			cy: 0,
			r: 1,
			gradientUnits: "userSpaceOnUse",
			gradientTransform: "translate(22.5 18) rotate(-31.6075) scale(7.63217)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .139843,
					stopColor: "#51B7D8"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .460561,
					stopColor: "#6A71FF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .785818,
					stopColor: "#AC8EFF"
				})
			]
		}) })
	]
});
export default SvgPortfolioColored;
